export class Customer {
  id?: string;
  fullName: string;
  documentType: string;
  documentTypeId: string;
  documentNumber: string;
  personType: string;
  personTypeId: string;
  phone: string;
  email: string;
  address: string;
  department: string;
  departmentId: string;
  city: string;
  cityId: string;
  neighborhood: string;
  notes: string;

  constructor(data: Partial<Customer> | any = {}) {
    this.id = data.id;
    this.fullName = data.fullName;
    this.documentType = data.documentType;
    this.documentTypeId = data.documentTypeId;
    this.documentNumber = data.documentNumber;
    this.personType = data.personType;
    this.personTypeId = data.personTypeId;
    this.phone = data.phone;
    this.email = data.email;
    this.address = data.address;
    this.department = data.department;
    this.departmentId = data.departmentId;
    this.city = data.city;
    this.cityId = data.cityId;
    this.neighborhood = data.neighborhood;
    this.notes = data.notes;
  }
}
